(function(){
  document.documentElement.classList.add('js-on');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{threshold:.12});
  function bindReveals(){document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function(el){
    if(el.getBoundingClientRect().top < innerHeight*.92){el.classList.add('is-in');return;} io.observe(el);});}
  bindReveals();
  document.addEventListener('shopify:section:load',bindReveals);

  var hdr=document.querySelector('.site-header');
  if(hdr){addEventListener('scroll',function(){hdr.classList.toggle('is-stuck',scrollY>20)},{passive:true});}

  function closeDrawer(){var d=document.querySelector('.drawer');if(d){d.classList.remove('is-open');document.body.classList.remove('drawer-open');}}
  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-drawer-open]');
    var close=e.target.closest('[data-drawer-close]');
    var d=document.querySelector('.drawer');
    if(!d)return;
    if(open){e.preventDefault();d.classList.add('is-open');document.body.classList.add('drawer-open');return;}
    if(close){e.preventDefault();closeDrawer();return;}
    if(d.classList.contains('is-open')&&e.target.closest('.drawer a')){closeDrawer();}
  });
  addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});
  document.addEventListener('shopify:section:load',closeDrawer);

  function initSlider(root){
    var slides=root.querySelectorAll('.hero__slide'), dots=root.querySelectorAll('.hero__dot');
    var dotWrap=root.querySelector('.hero__dots');
    if(slides.length<2){if(dotWrap)dotWrap.style.display='none';return;}
    var i=0, ms=parseInt(root.dataset.interval||'6000',10), timer=null;
    function go(n){i=(n+slides.length)%slides.length;
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===i)});
      dots.forEach(function(d,k){d.classList.toggle('is-active',k===i);d.setAttribute('aria-selected',k===i)});}
    function start(){if(root.dataset.autoplay!=='false'){stop();timer=setInterval(function(){go(i+1)},ms);}}
    function stop(){if(timer)clearInterval(timer)}
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);start();})});
    root.addEventListener('mouseenter',stop); root.addEventListener('mouseleave',start);
    go(0); start();
  }
  document.querySelectorAll('[data-hero-slider]').forEach(initSlider);
  document.addEventListener('shopify:section:load',function(e){
    var s=e.target.querySelector('[data-hero-slider]'); if(s)initSlider(s);
  });

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-media-thumb]'); if(!t)return;
    var root=t.closest('[data-product-media]'); if(!root)return;
    var main=root.querySelector('[data-media-main]'); if(main)main.src=t.dataset.full;
    root.querySelectorAll('[data-media-thumb]').forEach(function(x){x.classList.toggle('is-active',x===t)});
  });

  document.querySelectorAll('[data-variant-picker]').forEach(function(root){
    root.querySelectorAll('[data-variant]').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('[data-variant]').forEach(function(b){b.classList.toggle('is-active',b===btn)});
        var input=document.querySelector('[data-variant-id]'); if(input)input.value=btn.dataset.variant;
        var priceEl=document.querySelector('[data-live-price]'); if(priceEl&&btn.dataset.price)priceEl.textContent=btn.dataset.price;
        var cta=document.querySelector('[data-atc-label]');
        if(cta&&btn.dataset.price)cta.textContent=(cta.dataset.prefix||'Add to cart')+' \u2014 '+btn.dataset.price;
        var avail=btn.dataset.available==='true';
        var submit=document.querySelector('[data-atc]');
        if(submit){submit.disabled=!avail; if(!avail&&cta)cta.textContent='Sold out';}
      });
    });
  });
})();
